module.exports = __webpack_public_path__ + "static/media/DMSans-Bold.0ef08fc5.woff";